import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AIS140TicketListComponent } from './ais140-ticket-list.component';

const routes: Routes = [
  {
    path: 'ais140-ticket-list',
    data: { name: 'My AIS 140 Tickets', isTab: false },
    component: AIS140TicketListComponent,
  },
  {
    path: 'ais140-ticket-list',
    data: { name: 'My AIS 140 Tickets Master Access', isTab: true },
    component: AIS140TicketListComponent,
  },
  {
    path: 'ais140-ticket-list',
    data: { name: 'Certification Automation', isTab: true },
    component: AIS140TicketListComponent,
  },
  {
    path: 'ais140-ticket-list',
    data: { name: 'Server Monitoring Dashboard', isTab: true },
    component: AIS140TicketListComponent,
  },
  {
    path: 'ais140-ticket-list',
    data: { name: 'Vahan Tagging Automation', isTab: true },
    component: AIS140TicketListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AIS140TicketListRoutingModule {}
